import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Currency } from 'src/app/models/enums/currency';
import { CurrencyService } from 'src/app/services/currency.service';
import { OrderUtil } from 'src/app/utils/order.util';

@Component({
  selector: 'app-sling-order-details',
  templateUrl: './sling-order-details.component.html',
  styleUrls: ['./sling-order-details.component.scss']
})
export class SlingOrderDetailsComponent implements OnInit {

  sling: any;
  customers: any[];
  orders: any[];
  today: any = new Date();
  orderUtil: OrderUtil;
  currentCurrency: Currency = Currency.BRL;

  get unitValueFormat(): string {
    return this.currentCurrency === Currency.BRL ? '1.2-2' : '1.2-3';
  }

  constructor(
    public dialog: DynamicDialogRef,
    private router: Router,
    private config: DynamicDialogConfig,
    private currencyService: CurrencyService
  ) {
    this.orderUtil = new OrderUtil();
  }

  ngOnInit(): void {
    this.sling = this.config.data.sling;
    this.customers = this.config.data.customers;
    this.orders = this.config.data.orders;
    this.currentCurrency = this.currencyService.getCurrentCurrency();
  }

  singleOrder(): void {
    this.dialog.close();
    this.router.navigate(['single-order'], {
      queryParams: {
        customerId: this.sling.navigationPlan.responsible.id,
        boatId: this.sling.boat.id,
        slingId: this.sling.id
      }
    });
  }
}
